import type { IGetCustomerOrderDetailsQuery } from "@jti/magento";
import { getCurrentMagentoClient } from "@jti/magento";

const fetchOrderDetails = async (orderId: string, isFreeTrial = false): Promise<any> => {
  const orderDetailsObject: IGetCustomerOrderDetailsQuery =
    await getCurrentMagentoClient(isFreeTrial).getCustomerOrderDetails(orderId);
  const orderDetailsItems = orderDetailsObject?.customer?.orders?.items;

  if (!orderDetailsItems.length) {
    throw new Error("no items found in selected order");
  }

  const orderDetails = orderDetailsItems[0];

  if (!/new|payment failed/i.test(orderDetails.status)) {
    throw new Error("selected order is in incorrect status");
  }

  return orderDetails;
};

export default fetchOrderDetails;
